export enum Pannels {
  DetailsTab,
  ActivityTab,
  RelatedTab,
  SplitLinesPanel,
  ContactForm,
  InvoiceDetails,
  TaskDetails
}
